<template>
  <div class="share-wrapper">
    <div v-if="detailobj.remainGiveCourseNum == 0" class="cant_share">
      <div>
        <p>你已成功赠送{{detailobj.giveCourseNum}}位好友</p>
        <p class="tip">无法继续赠送</p>
      </div>
      <p class="read" @click="cancel">我知道了</p>
    </div>
    <div class="share_box" v-else>
      <p class="share_title"><img src="../../../static/images/gift.png">赠送给好友，帮助大家一起成长！</p>
      <div class="share_from">
        <p class="share_way" @click="shareToQq"><img src="../../../static/images/qqshare.png"><span>QQ</span></p>
        <p class="share_way" @click="shareToXl"><img src="../../../static/images/wbshare.png"><span>微博</span></p>
      </div>
      <p class="cancel" @click="cancel">取消</p>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      shareqqzonestring: '',
      sharesinastring: '',
      url: encodeURIComponent(this.detailobj.url + '?systemSn=' + this.detailobj.sn),
      picurl: 'https://xue.eoffcn.com/web/img/app_icon.png'
    }
  },
  props: ['detailobj'],
  methods: {
    shareToQq () {
      this.shareqqzonestring = 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?title=免费送你一个价值'+ this.detailobj.price/100 +'元的课程快来领取吧！&url='+ this.url +'&pics='+ this.picurl
      window.open(this.shareqqzonestring, 'newwindow', 'height=400,width=400,top=100,left=100')
    },
    shareToXl () {
      this.sharesinastring = 'http://v.t.sina.com.cn/share/share.php?title=免费送你一个价值'+ this.detailobj.price/100 +'元的课程快来领取吧！&url='+ this.url +'&content='+ this.detailobj.name +'&sourceUrl='+ this.url +'&pic='+ this.picurl
      window.open(this.sharesinastring, 'newwindow', 'height=400,width=400,top=100,left=100')
    },
    cancel () {
      this.$emit('share', false)
    }
  }
};
</script>
<style lang="less" scoped>
.share-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  background: rgba(0, 0, 0, .7);
  .cant_share {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 600px;
    height: 302px;
    text-align: center;
    background: #ffffff;
    border-radius: 20px;
    transform: translate(-50%, -50%);
    font-size: 32px;
    div {
      height: 190px;
      font-weight: bold;
      color: #333333;
      padding: 60px 0 48px;
      border-bottom: 1px solid #e5e5e5;
      .tip {
        color: #666666;
        font-size: 24px;
        font-weight: normal;
        margin-top: 24px;
      }
    }
    .read {
      line-height: 110px;
      color: #e60012;
    }
  }
  .share_box {
    position: fixed;
    bottom: 0;
    width: 100%;
	  height: 420px;
    background: #ffffff;
    border-radius: 20px 20px 0px 0px;
    padding: 32px 30px 40px;
    .share_title {
      display: flex;
      font-size: 30px;
      font-weight: bold;
      img {
        width: 44px;
        margin-right: 20px;
      }
    }
    .share_from {
      display: flex;
      margin-top: 36px;
      .share_way {
        text-align: center;
        margin-right: 50px;
        span {
          font-size: 26px;
        }
        img {
          display: block;
          width: 90px;
          height: 90px;
          margin-bottom: 14px;
        }
      }
    }
    .cancel {
      display: block;
      width: 690px;
	    height: 98px;
      text-align: center;
      line-height: 98px;
      font-size: 34px;
      color: #e60012;
      border: 1px solid #e60012;
      border-radius: 50px;
      margin-top: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/share/index.vue